import React from 'react';
import { PostHogProvider } from './PostHogProvider';
import { SportThemeProvider } from '../contexts/SportThemeContext';
import { AuthProvider } from '../contexts/AuthContext';
import { GameRegistryProvider } from '../contexts/GameRegistryContext';
import { ModalProvider } from '../contexts/ModalContext';

interface ProviderHierarchyProps {
  children: React.ReactNode;
}

/**
 * Central provider hierarchy for the application.
 * Providers are organized from outermost to innermost based on dependencies.
 * Note: This must be used inside RouterProvider since PostHogProvider uses useLocation.
 */
export function ProviderHierarchy({ children }: ProviderHierarchyProps) {
  return (
    <PostHogProvider>
      <SportThemeProvider>
        <AuthProvider>
          <ModalProvider>
            <GameRegistryProvider>
              {children}
            </GameRegistryProvider>
          </ModalProvider>
        </AuthProvider>
      </SportThemeProvider>
    </PostHogProvider>
  );
}